import { baseInfoQueryOptions } from "@/api/base-info";
import { queryClient } from "@/app/query-client";
import { CheckoutPage } from "@/features/protection-widget/checkout/checkout-page";
import { widgetSearch } from "@/features/protection-widget/widget-navigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/widget/checkout")({
  validateSearch: widgetSearch,
  beforeLoad: async ({ search }) => {
    const info = await queryClient.query({ ...baseInfoQueryOptions(), staleTime: "static" });
    if (!info.is_plus) {
      throw redirect({ to: "/widget/cart", search, replace: true });
    }
  },
  component: CheckoutRoute,
});

function CheckoutRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CheckoutPage
      {...search}
      onConsumeIntent={() => void navigate({ search: {}, replace: true, resetScroll: false })}
    />
  );
}
